import iconMixin from '../../mixins/iconMixin'

export default {
  mixins: [iconMixin],
  data: function () {
    return {
      viewBox: "0 0 24 24",
      rawSvgPath: '<path d="M19,13h-6v6h-2v-6H5v-2h6V5h2v6h6V13z"/>',
    }
  },
}